import * as React from "react";
import { cn } from "@/utils/cn";

export interface SelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  icon?: React.ReactNode;
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, icon, children, ...props }, ref) => {
    const hasIcon = !!icon;

    return (
      <div className={cn("relative flex items-center", hasIcon ? "" : "")}>
        {icon && (
          <span className="absolute left-3 text-[#7b2a40] opacity-80 pointer-events-none">
            {icon}
          </span>
        )}
        <select
          ref={ref}
          {...props}
          className={cn(
            "w-full appearance-none rounded-md border border-gray-300 bg-white text-gray-900 text-sm",
            "focus:outline-none focus:ring-2 focus:ring-[#7b2a40]/50 focus:border-[#7b2a40]",
            "disabled:cursor-not-allowed disabled:opacity-50",
            hasIcon ? "pl-10 pr-8 py-3" : "px-3 py-3",
            "transition-all duration-150 ease-in-out",
            className
          )}
        >
          {children}
        </select>

        {/* Default down arrow */}
        <svg
          className="absolute right-3 w-4 h-4 text-gray-400 pointer-events-none"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </div>
    );
  }
);
Select.displayName = "Select";

export { Select };
